import React from 'react';

import './countrySelect.styl';

const Countryselect = (props) => {
  const options = props.items.map(item =>
    <option key={`countrySelect-${item.Country_Code}`} value={item.Country_Code}>{item[`Country_Label_${props.currentLanguage}`]}</option>
  );

  return (
    <select
      className="country-select__select"
      defaultValue={props.activeItem}
      onChange={props.onChange}
    >
      {options}
    </select>
  );
};

export default Countryselect;



// WEBPACK FOOTER //
// ./src/components/CountrySelect/index.js